var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.show)?_c('div',{staticClass:"article-info-ttsPlayer"},[(_vm.ttsUrl)?_c('audio',{attrs:{"id":`ttv-article-${_vm.article.id}`,"title":_vm.title,"src":_vm.ttsUrl,"controls":"","playsinline":"","webkit-playsinline":"","autoplay":""}}):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }